import { DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
  bgColor: '#F1E5D1',
  boardColor: '#254336',
  cardColor: '#FEFEDF',
  textColor: '#254336',
  boardtextColor: 'white',
  deleteBtn: 'white',
  toggle: '#F1E5D1',
  trash: '#254336',
};

export const darkTheme: DefaultTheme = {
  bgColor: '#254336',
  boardColor: '#F1E5D1',
  cardColor: '#6B8A7A',
  textColor: '#F1E5D1',
  boardtextColor: 'black',
  deleteBtn: '#254336',
  toggle: '#254336',
  trash: '#F1E5D1',
};
